<template>
  
  <div id="view-exterior-container">
    <div class="container is-fluid levebar-container">
      <nav class="level app-levelbar">
        <div class="level-left is-hidden-mobile">
          <breadcrumb v-if="breadcrumbList" :list="breadcrumbList"></breadcrumb>
        </div>
      </nav>
    </div>

    <div id="view-exterior">

      <div class="container is-fluid">
        <div class="content content-padding">
          <h1 class="title">Lista de Slides de Exterior</h1>
          <div class="exteriors-list-holder">
            <hr>
            <exterior-card v-for="exterior in exteriors" :exterior="exterior" :exteriorTotal="exteriors.length"></exterior-card>
          </div>

          <a class="button is-primary" @click="openExteriorEditModal">
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>Criar</span>
          </a>
        </div>
     </div>

    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../Util/Breadcrumb'
  import ExteriorCard from './ExteriorCard'
  import Vue from 'vue'
  import ExteriorEditModal from './ExteriorEditModal'

  const ExteriorEditModalComponent = Vue.extend(ExteriorEditModal)

  export default {
    components: {
      Breadcrumb,
      ExteriorCard
    },

    data () {
      return {
        breadcrumbList: null,
        coachId: this.$store.state.route.params.id
      }
    },

    mounted () {
      this.getExteriorsList()
      this.getCoachData()
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },

      coach () {
        return this.$store.state.coach.data
      },

      exteriors () {
        return this.$store.state.exterior.data
      }
    },

    methods: {
      getExteriorsList () {
        this.$store.dispatch('getExteriorsList', {coachId: this.coachId})
      },

      getCoachData () {
        this.$store.dispatch('getCoach', this.$store.state.route.params.id)
      },

      openExteriorEditModal () {
        let openCardModalExterior = (propsData = {}) => {
          return new ExteriorEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModalExterior({
          title: 'Criar Exterior',
          exteriorTotal: this.exteriors.length,
          exteriorData: null
        })
      }
    },

    watch: {
      currentEvent: function (val) {
        if (val === 'update-exterior-list') {
          this.getUserList()
        }
      },

      coach: function (val) {
        if (val) {
          let id = val.id
          let name = val.languages[0].pivot.name

          this.breadcrumbList = [
            { name: 'Início', path: '/' },
            { name: `${name}`, path: `/${id}` },
            { name: 'VISITA EXTERIOR', path: '' }
          ]
        }
      }
    }
  }
</script>

<style lang="scss">
  .content-padding {
    padding: 10px;
    background: white;
  }
  #view-exterior-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .container-margin-top {
    margin-top: 20px !important;
  }

  .flex-container-center {
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// index.vue?4fb9864d